/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content/Preview/Content/Email",
  isInvalid,
  onChange
  
}) {
let selectedEmailValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'email',
})
let selectedEmailChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'email',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 label="Email"
 type="email"
 validate="/Data/validate.js email"
 invalid={isInvalid}
 data="selected.email"
 value={selectedEmailValueData}
 onChange={selectedEmailChangeData}
/>
{children}
</React.Fragment>)
}